<template>
    <section class="container relative">
        <AtomTitle class="text-center max-md:text-20/120">
            Приглашаем Вас на&nbsp;чашку свежего зернового кофе в&nbsp;наши
            офисы, чтобы познакомиться поближе
        </AtomTitle>
        <div class="relative ml-4 flex justify-center md:ml-7 md:mt-20 lg:ml-6">
            <picture>
                <source
                    type="image/webp"
                    srcset="/assets/images/ui/objects/webp/cup-steam.webp" />
                <img
                    loading="lazy"
                    width="312"
                    height="266"
                    alt="анимированный пар от кружки кофе"
                    src="/assets/images/ui/objects/jpg-png/cup-steam.png"
                    class="absolute h-[11.625rem] w-[10rem] animate-steam md:h-[16.625rem] md:w-[19.5rem]" />
            </picture>
            <CoffeeCupIcon
                class="h-[25rem] w-[14rem] max-sm:h-[18.75rem] md:w-[22.5rem]" />
        </div>
        <div
            v-if="!hideContactButton"
            class="mt-10 text-center md:mt-20">
            <BaseLink
                to="/contacts"
                target="_blank"
                size="accent">
                Как нас найти?
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import CoffeeCupIcon from '~/components/pages/home/coffee-bean-section/CoffeeCupIcon.vue'

defineProps({
    hideContactButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})
</script>
